var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserDropdownIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75002 1.75C9.0722 1.75 9.33335 2.01117 9.33335 2.33333V3.5H12.25C12.5722 3.5 12.8334 3.76117 12.8334 4.08333V11.6667C12.8334 11.9888 12.5722 12.25 12.25 12.25H1.75002C1.42786 12.25 1.16669 11.9888 1.16669 11.6667V4.08333C1.16669 3.76117 1.42786 3.5 1.75002 3.5H4.66669V2.33333C4.66669 2.01117 4.92786 1.75 5.25002 1.75H8.75002ZM9.33335 4.66667H4.66669V11.0833H9.33335V4.66667ZM2.33335 4.66667V11.0833H3.50002V4.66667H2.33335ZM8.16669 2.91667H5.83335V3.5H8.16669V2.91667ZM10.5 4.66667V11.0833H11.6667V4.66667H10.5Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDropdownIcon02);
export default __webpack_public_path__ + "static/media/user-dropdown-icon--02.a5addc0f06ad5bc46e442856063c39cd.svg";
export { ForwardRef as ReactComponent };